import { AxiosError, isAxiosError } from 'axios';
import { redirect } from 'react-router-dom';
import AuthService from '../../services/Auth.service';

const resetPasswordLoader = async ({
	params,
}: {
	params: { token?: string };
}) => {
	const { token } = params;
	try {
		const data = await AuthService.verifyToken(token as string);
		return data;
	} catch (error) {
		sessionStorage.setItem('errorMessage', 'alert.error.token');
		throw redirect('/login');
	}
};

export default resetPasswordLoader;
